import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix the default icon issue in Leaflet with React
const DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerIconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const MapComponent = ({ lat, lng }) => {
  // Parse coordinates to make sure they're numbers
  const position = [parseFloat(lat) || 0, parseFloat(lng) || 0];

  return (
    <div className="map-container">
      <MapContainer
        center={position}
        zoom={13}
        style={{
          height: '220px',
          width: '100%',
          borderRadius: '6px',
          border: '1px solid #e0e0e0',
          maxWidth: '150px'
        }}
        zoomControl={false}
        attributionControl={false}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position} />
      </MapContainer>
    </div>
  );
};

export default MapComponent;
